var _defs, _rect, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmsLogoWordmarkDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 52",
    width: 420,
    height: 52,
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, "ProMeetService") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "logoTitle"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pmsMarkGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#115e59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f766e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 2,
    width: 44,
    height: 44,
    rx: 11,
    fill: "url(#pmsMarkGrad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 33,
    textAnchor: "middle",
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 19,
    fontWeight: 900,
    fill: "#ffffff",
    letterSpacing: "-0.03em"
  }, "P")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 34,
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize: 25,
    fontWeight: 800,
    letterSpacing: "-0.03em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#ffffff"
  }, "ProMeet"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#5eead4"
  }, "Service"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmsLogoWordmarkDark);
export default __webpack_public_path__ + "static/media/pms-logo-wordmark-dark.9499202ebea767cd354b6587b38a5f5f.svg";
export { ForwardRef as ReactComponent };